import { gql } from '@apollo/client'

// Need to split fragments because while graphql is incredibly verbose
// you cant even just include all...
// include the ones you need at the start of your queries with ${<fragment>}

// schema.graphql
export const fragmentUser = gql`
    fragment fragmentUser on User {
        id
        name
    }
`
export const fragmentDataTypeChange = gql`
    ${fragmentUser}
    fragment fragmentDataTypeChange on DataTypeChange {
        user {
            ...fragmentUser
        }
        timestamp
        changeType
    }
`

// dataTypeQuery.graphql
export const fragmentAttributeCommon = gql`
    fragment fragmentAttributeCommon on AttributeCommon {
        identifier
        name
        description
        visible
        _next
    }
`

export const fragmentsAttributes = gql`
    ${fragmentAttributeCommon}
    fragment fragmentAttributeText on AttributeText {
        id
        common {
            ...fragmentAttributeCommon
        }
        multiLine
        defaultValue
    }
    fragment fragmentAttributeNumber on AttributeNumber {
        id
        common {
            ...fragmentAttributeCommon
        }
        integer
        min
        max
        defaultValue
    }
    fragment fragmentAttributeBoolean on AttributeBoolean {
        id
        common {
            ...fragmentAttributeCommon
        }
        defaultValue
    }
    fragment fragmentAttributeAsset on AttributeAsset {
        id
        common {
            ...fragmentAttributeCommon
        }
    }
    fragment fragmentAttributeLink on AttributeLink {
        id
        common {
            ...fragmentAttributeCommon
        }
        allowed
    }
    fragment fragmentAttributeSelection on AttributeSelection {
        id
        common {
            ...fragmentAttributeCommon
        }
        options {
            id
            name
            description
        }
        defaultValue
    }
    fragment fragmentAttributeCollection on AttributeCollection {
        id
        common {
            ...fragmentAttributeCommon
        }
        dataType
    }
`
export const fragmentDataType = gql`
    ${fragmentsAttributes}
    ${fragmentDataTypeChange}
    fragment fragmentDataType on DataType {
        id
        category
        identifier
        name
        description
        created {
            ...fragmentDataTypeChange
        }
        updated {
            ...fragmentDataTypeChange
        }
        _head
        attributeTextList {
            ...fragmentAttributeText
        }
        attributeNumberList {
            ...fragmentAttributeNumber
        }
        attributeBooleanList {
            ...fragmentAttributeBoolean
        }
        attributeAssetList {
            ...fragmentAttributeAsset
        }
        attributeLinkList {
            ...fragmentAttributeLink
        }
        attributeSelectionList {
            ...fragmentAttributeSelection
        }
        attributeCollectionList {
            ...fragmentAttributeCollection
        }
    }
`
export const fragmentDataItemChange = gql`
    ${fragmentUser}
    fragment fragmentDataItemChange on DataItemChange {
        user {
            ...fragmentUser
        }
        timestamp
        changeType
    }
`

export const fragmentDataItem = gql`
    ${fragmentDataItemChange}
    fragment fragmentDataItem on DataItem {
        id
        published
        created {
            ...fragmentDataItemChange
        }
        updated {
            ...fragmentDataItemChange
        }
        attributeTextValues {
            attributeID
            value
        }
        attributeNumberValues {
            attributeID
            value
        }
        attributeBooleanValues {
            attributeID
            value
        }
        attributeAssetValues {
            attributeID
            value
            alt
        }
        attributeLinkValues {
            attributeID
            value
            newWindow
        }
        attributeSelectionValues {
            attributeID
            value
        }
        attributeCollectionValues {
            attributeID
            value {
                id
                attributeTextValues {
                    attributeID
                    value
                }
                attributeNumberValues {
                    attributeID
                    value
                }
                attributeBooleanValues {
                    attributeID
                    value
                }
                attributeAssetValues {
                    attributeID
                    value
                    alt
                }
                attributeLinkValues {
                    attributeID
                    value
                    newWindow
                }
                attributeSelectionValues {
                    attributeID
                    value
                }
            }
        }
    }
`
